import { FileExportType } from '../interfaces/FileExport';

export const possibleFileExportTypes: FileExportType[] = [FileExportType.EXCEL];
